<template>
  <ul class="list-reset flex">
    <li>
      <a class="no-underline text-blue pr-3" href>Dashboard</a>
    </li>
    <li>
      <a class="no-underline text-grey-dark" href>Dashboard</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "TheBreadcrumb"
};
</script>



// WEBPACK FOOTER //
// src/components/TheBreadcrumb.vue